var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeleconsultChatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.37109,
    r: 9,
    fill: "#FF725E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3359 5.20508H5.66927C5.21094 5.20508 4.8401 5.58008 4.8401 6.03841L4.83594 13.5384L6.5026 11.8717H12.3359C12.7943 11.8717 13.1693 11.4967 13.1693 11.0384V6.03841C13.1693 5.58008 12.7943 5.20508 12.3359 5.20508ZM6.5026 8.12174H11.5026V8.95508H6.5026V8.12174ZM9.83594 10.2051H6.5026V9.37174H9.83594V10.2051ZM11.5026 7.70508H6.5026V6.87174H11.5026V7.70508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleconsultChatIcon);
export default __webpack_public_path__ + "static/media/teleconsult-chat-icon.2706695578317240d2c7c368ea4869dd.svg";
export { ForwardRef as ReactComponent };